<template>
    <v-row no-gutters>
        <template>
            <v-card min-height="90vh" elevation="4" class="p-0">
                <v-card-title class="font-weight-normal pl-4"
                    style="border-bottom: 1.5px solid #fbc02d;border-radius: 0;">Kelola pengguna</v-card-title>
                <div class="p-3">
                    <v-card class="mb-3" style="background-color: #f3f6f9;" elevation="0">
                        <v-container>
                            <div class="text-caption pb-1 indigo--text text--darken-4">
                                Filter
                            </div>
                            <v-row>
                                <v-col cols="12" md="6">
                                    <v-select small-chips dense class="pb-0" :items="selectOptions.roles"
                                        v-model="roleDefaultValue" label="Otoritas" @change="onChangeRole($event)"
                                        solo></v-select>
                                </v-col>
                                <v-col v-if="showProdi" cols="12" md="6">
                                    <v-select small-chips dense class="pb-0" :items="selectOptions.prodis" multiple
                                        v-model="prodiDefaultValue" label="Prodi" @change="onChangeProdi($event)"
                                        solo></v-select>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-card>
                    <v-card elevation="1">
                        <v-card-title>
                            <v-row>
                                <v-col md="4" sm="12">
                                    <v-text-field v-model="search" @blur="onBlurSearch($event)" @keyup="onKeyup($event)" append-icon="mdi-magnify" label="Cari" single-line
                                        hide-details></v-text-field>
                                </v-col>
                            </v-row>
                        </v-card-title>
                        <v-data-table :headers="headers" :items="users" item-key="name" :search="search" :server-items-length="count" @pagination="onChangePagination($event)"
                            :loading="isLoading" loading-text="Mengambil data... Mohon tunggu">
                            <template v-slot:top>
                                <v-toolbar flat>
                                    <v-divider class="mx-2" inset vertical></v-divider>
                                    <v-spacer></v-spacer>
                                    <v-dialog v-model="dialogImport" max-width="500px">
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-btn color="indigo darken-4 white--text" outlined dark class="mb-2 mr-2"
                                                v-bind="attrs" v-on="on">
                                                <v-icon left dark>
                                                    mdi-file-plus
                                                </v-icon>
                                                Import Xlsx
                                            </v-btn>
                                        </template>
                                        <v-card>
                                            <v-card-title class="text-body-1 indigo darken-4 white--text">Import
                                                pengguna</v-card-title>
                                            <v-container>
                                                <v-card elevation="0">
                                                    <v-card-title
                                                        class="text-body-1 indigo--text text--darken-4 font-weight-bold">Unggah
                                                        berkas</v-card-title>
                                                    <v-card-subtitle
                                                        class="text-caption indigo--text text--darken-4">Format: pdf
                                                        (Maksimal
                                                        2mb)</v-card-subtitle>
                                                    <v-container>
                                                        <v-file-input @change="onChangeFileInput($event)" show-size
                                                            placeholder="Unggah berkas" label="Unggah disini" multiple
                                                            prepend-icon="mdi-file">
                                                            <template v-slot:selection="{ text }">
                                                                <v-chip small label color="primary">
                                                                    {{ text }}
                                                                </v-chip>
                                                            </template>
                                                        </v-file-input>
                                                    </v-container>
                                                </v-card>
                                            </v-container>
                                            <v-card-actions>

                                                <v-spacer></v-spacer>
                                                <v-btn color="indigo darken-4" outlined text
                                                    @click="dialogImport = false">Batal</v-btn>
                                                <v-btn color="indigo darken-4" class="white--text"
                                                    @click="errorToast">Import</v-btn>
                                                <v-spacer></v-spacer>
                                            </v-card-actions>
                                        </v-card>
                                    </v-dialog>
                                    <v-dialog v-model="dialog" persistent max-width="500px">
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-btn color="indigo darken-4 white--text" dark class="mb-2 ml-2" v-bind="attrs"
                                                v-on="on">
                                                <v-icon left dark>
                                                    mdi-account-plus
                                                </v-icon>
                                                Tambah
                                            </v-btn>
                                        </template>
                                        <v-card>
                                            <v-card-title class="text-body-1 indigo darken-4 white--text">
                                                {{ form_status == 'update' ? 'Ubah ' : 'Tambah ' }}Pengguna</v-card-title>
                                            <v-container>
                                                <v-form ref="form" v-model="valid" lazy-validation>
                                                    <v-select :rules="$rules.required" v-model="role_id" deletable-chips
                                                        :items="roleItem" item-disabled="disabled" :label="$t('role')"
                                                        multiple chips persistent-hint
                                                        :menu-props="{ closeOnContentClick: true }"></v-select>
                                                    <template v-if="role_id.length > 0">
                                                        <v-select v-if="showProdi" :rules="$rules.required" v-model="prodi_id" deletable-chips
                                                            :items="prodiItem" item-disabled="disabled" :label="'Prodi'"
                                                            multiple chips persistent-hint
                                                            :menu-props="{ closeOnContentClick: true }"></v-select>
                                                        <v-text-field :rules="$rules.required" v-model="name"
                                                            :label="$t('full_name') + '*'" type="text"
                                                            required></v-text-field>
                                                        <v-text-field :rules="$rules.required" v-model="email"
                                                            label="Email*" type="email" required></v-text-field>
                                                        <v-text-field :rules="$rules.required"
                                                            v-model="identification_number" :label="role_id.includes(4)
                                                                ? $t('student_number')
                                                                : $t('employee_number') + '*'
                                                                " type="number" required></v-text-field>
                                                        <v-text-field v-model="phone_number" :label="$t('phone_number')"
                                                            type="number" required></v-text-field>
                                                    </template>
                                                </v-form>
                                            </v-container>
                                            <v-card-actions>
                                                <v-spacer></v-spacer>
                                                <v-btn color="indigo darken-4" outlined text
                                                    @click="resetDialog()">Batal</v-btn>
                                                <v-btn color="indigo darken-4" class="white--text"
                                                    @click="submit">Simpan</v-btn>
                                                <v-spacer></v-spacer>
                                            </v-card-actions>
                                        </v-card>
                                    </v-dialog>
                                    <v-dialog v-model="dialogDelete" max-width="500px">
                                        <v-card>
                                            <v-card-title class="text-h5">Apakah yakin ingin menghapus pengguna
                                                ini?</v-card-title>
                                            <v-card-actions>
                                                <v-spacer></v-spacer>
                                                <v-btn color="indigo darken-4" outlined text
                                                    @click="dialogImport = false">Batal</v-btn>
                                                <v-btn color="indigo darken-4" class="white--text"
                                                    @click="deleteItemConfirm">Simpan</v-btn>
                                                <v-spacer></v-spacer>
                                            </v-card-actions>
                                        </v-card>
                                    </v-dialog>
                                </v-toolbar>
                            </template>
                            <template v-slot:item.authority="{ item }">
                                <v-chip :class="[item.admin ? 'green' : 'red']">
                                    <v-icon color="white">{{
                                        item.admin ? 'mdi-check-circle' :
                                        'mdi-close-circle'
                                    }}</v-icon>
                                </v-chip>
                                <v-chip :class="[item.officer ? 'green' : 'red']">
                                    <v-icon color="white">{{
                                        item.officer ? 'mdi-check-circle' :
                                        'mdi-close-circle'
                                    }}</v-icon>
                                </v-chip>
                                <v-chip :class="[item.lecture ? 'green' : 'red']">
                                    <v-icon color="white">{{
                                        item.lecture ? 'mdi-check-circle' :
                                        'mdi-close-circle'
                                    }}</v-icon>
                                </v-chip>
                                <v-chip :class="[item.student ? 'green' : 'red']">
                                    <v-icon color="white">{{
                                        item.student ? 'mdi-check-circle' :
                                        'mdi-close-circle'
                                    }}</v-icon>
                                </v-chip>
                            </template>
                         
                            <template v-slot:item.actions="{ item }">
                                <v-icon color="dark" class="mr-2" @click="editItem(item)">
                                    mdi-pencil
                                </v-icon>
                                <!-- <v-icon color="dark" @click="deleteItem(item)">
                                    mdi-delete
                                </v-icon> -->
                            </template>
                            <template v-slot:no-data>
                                <v-btn color="primary" @click="initialize">
                                    Mulai ulang
                                </v-btn>
                            </template>

                        </v-data-table>
                    </v-card>
                </div>
            </v-card>
        </template>
    </v-row>
</template>
<script>
export default {
    data: () => ({
        allowedPerson: [115230402, 211232636, 211232637, 211232638],
        itemsPerPage: 0,
        showProdi: false,
        selectOptions: {
            roles: [],
            prodis: []
        },
        limit: 10,
        offset: 0,
        count: 100,
        roleItem: [],
        prodiItem: [],
        name: '',
        role_id: [],
        prodi_id: [],
        valid: true,
        identification_number: "",
        phone_number: "",
        email: "",
        editedUser: '',
        isLoading: false,
        roleDefaultValue: '',
        prodiDefaultValue: [],
        role_id_filter: '',
        prodi_id_filter: [],
        users: [],
        user: JSON.parse(localStorage.getItem("user")),
        search: '',
        dialogImport: false,
        dialog: false,
        dialogDelete: false,
        form_status: 'create',
        headers: [
            {
                text: 'Nama',
                align: 'start',
                value: 'name',
            },
            {
                text: 'No Induk',
                value: 'no_induk',
            },
            { text: 'Prodi', value: 'program', width: '200px'},
            { text: 'Admin-Petugas-Dosen-Mahasiswa', value: 'authority' },
            { text: 'Actions', value: 'actions', sortable: false },
        ],
    }),
    created() {
        console.log('logged', localStorage.getItem("isAuth", true));
        // this.initialize();
        this.getRolesFilter();
        this.getProdisFilter();
        //Cek otritas untuk menampilkan prodi
        this.showProdi = true;
        this.prodiDefaultValue = this.user.prodis.map(el => {
                    return el.id;
                });
        if(!this.showProdi) {
            this.prodi_id = this.prodiDefaultValue
        };
    },
    watch:{
    },
    methods: {
        errorToast() {
            this.$emit("toast", "error", 'Maaf, fitur ini belum tersedia');
            this.dialogImport = false;
        },
        onChangeRole(event) {
            this.role_id_filter = event;
            this.getData();
        },
        onChangeProdi(event) {
            if (event[(event.length-1)] ==-1) this.prodiDefaultValue = [-1];
            else {
                if (event.includes(-1)){
                    let i = this.prodiDefaultValue.indexOf(-1);
                    i !== -1 ? this.prodiDefaultValue.splice(i, 1) : '';
                }
            }
            this.getData();
        },
        getRolesFilter() {
            this.isLoading = true;
            this.axios.get("/api/setting/roles").then((res) => {
                this.selectOptions.roles = res.data.data ?? [];
                this.selectOptions.roles.unshift({
                    text: 'Semua otoritas',
                    value: '',
                })
                this.selectOptions.roles.push({
                    text: 'Tidak memiliki otoritas',
                    value: -1,
                })
                this.roleItem = this.selectOptions.roles.filter(x => {
                    return x.value !== -1 && x.value !== '';
                })
            }).finally(() => {
                this.isLoading = false;
            });
        },
        getProdisFilter() {
            this.isLoading = true;
            this.axios.get("/api/setting/prodis").then((res) => {
                this.selectOptions.prodis = res.data.data ?? [];
                this.selectOptions.prodis.push({
                    text: 'Tidak memiliki prodi',
                    value: -1,
                })
                this.prodiItem = this.selectOptions.prodis.filter(x => {
                    return x.value !== -1 && x.value !== '';
                })
               
            }).finally(() => {
                this.isLoading = false;
                this.getData();
            });
        },
        getData() {
            const params = {
                role_id: this.role_id_filter,
                prodi_id: this.prodiDefaultValue,
                limit: this.limit,
                offset: this.offset,
                search: this.search
            };
            this.isLoading = true;
            this.axios.get("/api/setting/user", { params: params }).then((res) => {
                this.users = res.data.data ?? [];
                this.count = res.data.count || 100;
                this.users.forEach((element) => {
                    element.admin = element.roles.find(ro => ro.id == 1);
                    element.officer = element.roles.find(ro => ro.id == 2);
                    element.lecture = element.roles.find(ro => ro.id == 3);
                    element.student = element.roles.find(ro => ro.id == 4);
                    let prodis = element.prodis.map(val => {
                        return val.prodi;
                    });
                    element.program = prodis.join(', ');
                });
            }).finally(() => this.isLoading = false);
        },
        initialize() {
            this.role_id_filter = '';
            this.roleDefaultValue = '';
            this.getData();
        },
        onChangePagination(event){
            this.limit = event.itemsPerPage;
            this.offset =  event.itemsPerPage * (event.page - 1);
            this.getData();
        },
        onBlurSearch(event){
            this.getData();
        },
        onKeyup(event){
            if (event.keyCode == 13){
                this.getData();
            }
        },
        editItem(user) {
            this.editedUser = user.id;
            this.form_status = "update";
            this.role_id = user.roles.map((x) => x.id);
            this.prodi_id = user.prodis.map((x) => x.id);
            this.name = user.name;
            this.identification_number = user.no_induk;
            this.phone_number = user.no_hp;
            this.email = user.email;
            this.dialog = true
        },

        deleteItem(item) {
            this.editedIndex = this.desserts.indexOf(item)
            this.editedItem = Object.assign({}, item)
            this.dialogDelete = true
        },
        deleteItemConfirm() {
            this.desserts.splice(this.editedIndex, 1)
            this.closeDelete()
        },
        resetDialog() {
            this.form_status = 'create';
            this.dialog = false;
            this.name = "";
            this.identification_number = "";
            this.phone_number = "";
            this.email = "";
            this.role_id = [];
            this.$refs.form.reset();
        },
        submit() {
            const valid = this.$refs.form.validate();
            if (valid) {
                this.isLoading = true;
                const params = {
                    name: this.name,
                    no_induk: this.identification_number,
                    no_hp: this.phone_number,
                    email: this.email,
                    role_id: this.role_id,
                    prodi_id: this.prodi_id
                };

                let url = "/api/setting/user";
                if (this.form_status === "update") {
                    params["_method"] = "put";
                    url = url + "/" + this.editedUser;
                }
                this.axios
                    .post(url, params)
                    .then((res) => {
                        this.isLoading = false;
                        this.$emit("toast", "success", res.data.message);
                        this.getData();
                        this.resetDialog();
                    })
                    .catch((err) => console.log(err))
                    .finally(() => {
                        this.isLoading = false;
                        this.form_status = 'create';
                    });
            }
        },
    },
}
</script>